import { GetAuthorizedEntitiesInput } from "@amzn/coral_com-amazon-carrierlogisticswebserver-model";
import CarrierLogisticsWebServerClient from "../clients/CarrierLogisticsWebServerClient";
export function getAuthorizedLpsService() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return CarrierLogisticsWebServerClient.getAuthorizedLogisticsParties(input);
}
export function getAuthorizedEntitiesService(input) {
    return CarrierLogisticsWebServerClient.getAuthorizedEntities(GetAuthorizedEntitiesInput.clone(input));
}
export function getLpDetailsService() {
    var input = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return CarrierLogisticsWebServerClient.getLogisticsPartyDetails(input);
}

//# sourceMappingURL=clwsService.js.map